var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"tablist"}},[_vm._l((_vm.group(_vm.value)),function(group){return [_c('postcode-accordion',{key:group.id,attrs:{"group":group},on:{"remove":_vm.remove,"removeGroup":_vm.removeGroup}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }